import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import {
  BudgetResponseSchema,
  SetBudgetResponseSchema,
  SetLoggingResponseSchema,
} from "@/api/schemas";

export function useBudget(tenantId: string) {
  return useQuery({
    queryKey: ["budget", tenantId],
    queryFn: async () => {
      const json = await api
        .get("tenant/budget")
        .json();
      return BudgetResponseSchema.parse(json);
    },
    enabled: !!tenantId,
  });
}

export function useSetBudget() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      tenantId: _tenantId,
      monthly_budget_usd,
    }: {
      tenantId: string;
      monthly_budget_usd: number;
    }) => {
      const json = await api
        .post("tenant/budget", {
          json: { monthly_budget_usd },
        })
        .json();
      return SetBudgetResponseSchema.parse(json);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["budget", variables.tenantId],
      });
    },
  });
}

export function useSetLogging() {
  return useMutation({
    mutationFn: async ({
      tenantId: _tenantId,
      content_logging_enabled,
    }: {
      tenantId: string;
      content_logging_enabled: boolean;
    }) => {
      const json = await api
        .post("tenant/logging", {
          json: { content_logging_enabled },
        })
        .json();
      return SetLoggingResponseSchema.parse(json);
    },
  });
}
